import { ImagoSpinner } from '../ui/ImagoSpinner';

/**
 * PageLoader - A full-page loading state component
 * 
 * @param {Object} props
 * @param {string} [props.message] - Optional loading message
 * @param {string} [props.className] - Additional CSS classes
 */
export function PageLoader({
  message = 'Loading...',
  className = '',
  ...rest
}) {
  return (
    <div
      className={`
        flex flex-col items-center justify-center
        min-h-screen w-full
        bg-background
        ${className}
      `.replace(/\s+/g, ' ').trim()}
      role="status"
      aria-live="polite"
      {...rest}
    >
      <ImagoSpinner size="lg" />
      {message && (
        <p className="mt-4 text-foreground-secondary text-sm">
          {message}
        </p>
      )}
    </div>
  );
}

/**
 * ContentLoader - A content area loading state (not full page)
 * 
 * @param {Object} props
 * @param {string} [props.message] - Optional loading message
 * @param {string} [props.className] - Additional CSS classes
 */
export function ContentLoader({
  message,
  className = '',
  ...rest
}) {
  return (
    <div
      className={`
        flex flex-col items-center justify-center
        py-12
        ${className}
      `.replace(/\s+/g, ' ').trim()}
      role="status"
      aria-live="polite"
      {...rest}
    >
      <ImagoSpinner size="md" />
      {message && (
        <p className="mt-3 text-foreground-secondary text-sm">
          {message}
        </p>
      )}
    </div>
  );
}

export default PageLoader;
